import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";

import { SummaryTable } from "./SummaryTable";

type TAdminPremiumBreakdownSection = {
  quote: TQuote;
};
export const AdminPremiumBreakdownSection: FC<TAdminPremiumBreakdownSection> = ({
  quote,
}) => {
  const { formatCurrency } = useFormatter();
  const basePremiumDetails = [
    {
      id: "pre-tax-premium",
      label: "Pre-tax premium",
      value: formatCurrency(quote?.preTaxPremium),
    },

    {
      id: "commission",
      label: "Commission",
      value: formatCurrency(quote?.commission),
    },
  ];

  const premiumDetailsFeesEtc = quote?.fees?.breakdown?.map((fee) => ({
    id: fee?.feeType?.key?.toLowerCase().split(" ").join("-"),
    label: fee?.feeType?.label,
    value: formatCurrency(fee?.amount),
  }));

  const premiumDetails = basePremiumDetails.concat(premiumDetailsFeesEtc);

  premiumDetails.push({
    id: "post-tax-premium",
    label: "Post-tax premium",
    value: formatCurrency(quote?.postTaxPremium),
  });

  premiumDetails.push({
    id: "amount-due",
    label: "Amount due",
    value: formatCurrency(quote?.amountDue),
  });

  return <SummaryTable data={premiumDetails} chunks={2} type="PREMIUM" />;
};
